export default __webpack_public_path__ + "newsela-logo-128x128.png";